import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { Icon } from '@livable/saas-react-components';
import { Accordion, AccordionDetails, AccordionSummary, Button, Paper, Typography } from '@mui/material';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';
import { UTILITIES_STATUSES } from 'src/constants/utilities';
import { useStore } from 'src/stores';
import { completedSteps } from 'src/utils/allocations';
import AllocationCounter from 'src/components/allocations/AllocationProgress/AllocationCounter';
import AllocationProgressBar from 'src/components/allocations/AllocationProgress/AllocationProgressBar';
import AllocationFromHistoryTable from './AllocationFromHistoryTable';
import useStyles from 'src/components/allocations/AllocationProgress/styles';
const AllocationFromHistory = props => {
  const classes = useStyles();
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const allocationCycleId = props.allocationCycleId,
    month = props.month,
    selectedBuilding = props.selectedBuilding,
    statementMonth = props.statementMonth,
    year = props.year,
    utilities = props.utilities,
    propertyData = props.propertyData;
  const statuses = store.allocations.allocationCounters.get(allocationCycleId);
  const availables = Object.keys(UTILITIES_STATUSES).filter(s => s === 'TableReadyStatementSent' || s === 'TableSkipped');
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  const _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    subMeterUtilitiesFinalStates = _useState4[0],
    setSubMeterUtilitiesFinalStates = _useState4[1];
  const getSubmeterFinalState = async _ref => {
    let utilityId = _ref.utilityId,
      billingCycleId = _ref.billingCycleId;
    return store.allocations.postGetSubMeterFinalStateAsync.run({
      propertyId: selectedBuilding,
      utilityId: utilityId,
      billingCycleId: billingCycleId
    });
  };
  const fetchSubMeterFinalStates = async () => {
    const results = {};
    for (const utility of utilities) {
      const utilityId = utility.utilityId;
      const billingCycleId = utility.billingCycleId;
      const subMeterFinalStateResp = await getSubmeterFinalState({
        utilityId,
        billingCycleId
      });
      if (subMeterFinalStateResp !== null && subMeterFinalStateResp !== void 0 && subMeterFinalStateResp.isSuccessful) {
        const subMeterFinalState = subMeterFinalStateResp.response;
        if (subMeterFinalState && subMeterFinalState.length) {
          results[utilityId] = subMeterFinalState;
        }
      }
    }
    setSubMeterUtilitiesFinalStates(results);
  };
  useEffect(() => {
    fetchSubMeterFinalStates();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/React.createElement(Paper, null, /*#__PURE__*/React.createElement("div", {
    className: classes.allocation
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.allocationInfo
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.allocationTitle
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, "".concat(month, " ").concat(year)), /*#__PURE__*/React.createElement(AllocationProgressBar, {
    completedSteps: completedSteps(statuses),
    totalSteps: utilities.length
  })), /*#__PURE__*/React.createElement(Button, {
    component: RouterLink,
    className: classes.openAllocationButton,
    disabled: utilities && !utilities.length,
    size: "small",
    to: "/allocation_tables?allocationCycleId=".concat(allocationCycleId, "&propertyId=").concat(selectedBuilding, "&fromHistory=true"),
    variant: "contained",
    'custom-attribute': '42-allocation-history'
  }, t('allocations.open_allocation_tables'))), /*#__PURE__*/React.createElement(Accordion, {
    className: classes.accordion,
    expanded: isOpen
  }, /*#__PURE__*/React.createElement(AccordionSummary, {
    "aria-controls": "allocation-content",
    expandIcon: /*#__PURE__*/React.createElement(Icon, {
      fontSize: "large",
      type: "arrow-line-right"
    }),
    id: "allocation-header",
    onClick: () => setIsOpen(prevValue => !prevValue)
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.accordionContent
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.title
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, t('allocations.view_allocation_summary'))), /*#__PURE__*/React.createElement("div", {
    className: classes.utilityIcons,
    onClick: e => e.stopPropagation(),
    onKeyDown: e => e.stopPropagation(),
    role: "button",
    tabIndex: 0
  }, utilities.length ? availables.map(status => /*#__PURE__*/React.createElement(AllocationCounter, {
    billStatus: status,
    key: status,
    statementDate: moment("".concat(statementMonth, " ", 1, ", ").concat(year)).format('L'),
    status: statuses[status] || []
  })) : null))), /*#__PURE__*/React.createElement(AccordionDetails, null, !utilities.length ? /*#__PURE__*/React.createElement("div", {
    className: classes.noUtilitiesHint
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    color: "light"
  }, t('allocations.no_allocations_for_property'))) : /*#__PURE__*/React.createElement(AllocationFromHistoryTable, {
    utilities: utilities,
    subMeterUtilitiesFinalStates: subMeterUtilitiesFinalStates,
    propertyData: propertyData,
    cycleName: "".concat(month, " ").concat(year)
  })))));
};
export default AllocationFromHistory;